import { RESET } from '../actionTypes';
import { companyGeneralActions } from '../reducer';

export default () => companyGeneralActions[RESET]();
